module.exports = __webpack_public_path__ + "9fef138b7f92801b7dbfb3afcc023e53.webp";